import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/constructionUpdatesPage/ConstructionUpdatesPageComponent.tsx");
